/**
 * An icon button in the review tab bar: the file tree toggle, the file search toggle and the
 * comments control share it, so the bar reads as one toolbar. It stays square until a button adds
 * text next to its icon, as the comments count does.
 */
export const PR_V2_TOOLBAR_ICON_BUTTON_CLASSNAME =
  'inline-flex h-6 min-w-6 shrink-0 items-center justify-center gap-1 rounded text-zinc-400 hover:bg-zinc-900 hover:text-zinc-100';

/**
 * A text button in the review tab bar: the file tree's view mode and the version picker share it,
 * so the bar reads as one toolbar.
 */
export const PR_V2_TOOLBAR_TEXT_BUTTON_CLASSNAME =
  'inline-flex h-6 items-center rounded px-1.5 text-[10px] font-medium uppercase tracking-wide text-zinc-400 hover:bg-zinc-900 hover:text-zinc-100';
